<template>
    <div>
        <div class="task-info-edital" :style="'width:' + width + 'px;'">
            <div class="title">
                {{ tip.name }}
            </div>
            <el-row :gutter="16">
                <el-col class="laber"> {{ translate('taskPage.left.executionStatus') }}</el-col>
                <!-- <el-col :span="7"> -->
                <div
                    :class="{
                        'is-unstart': tip.taskStatus == 1,
                        'is-starting': tip.taskStatus == 2,
                        'is-started': tip.taskStatus == 3,
                        'is-resulted': tip.taskStatus == 4,
                        'is-end': tip.taskStatus == 5,
                        'is-stop': tip.taskStatus == 6,
                    }"
                    class="value line-height-20"
                >
                    {{
                        tip.taskStatus == 1
                            ? translate('taskPage.left.pendingExecution')
                            : '' || tip.taskStatus == 2
                            ? translate('taskPage.left.executing')
                            : '' || tip.taskStatus == 3
                            ? translate('taskPage.left.pendingUploadData')
                            : '' || tip.taskStatus == 4
                            ? translate('taskPage.left.pendingUploadData')
                            : '' || tip.taskStatus == 5
                            ? translate('taskPage.left.completed')
                            : '' || tip.taskStatus == 6
                            ? translate('taskPage.left.terminated')
                            : ''
                    }}
                </div>
                <!-- </el-col> -->
            </el-row>
            <el-row :gutter="16">
                <el-col class="timelaber">
                    {{
                        tip.taskStatus == 1
                            ? translate('taskPage.left.planExecutionTime')
                            : translate('taskPage.left.actualExecutionTime')
                    }}
                </el-col>
                <el-col :span="14">
                    {{ tip.taskStatus != 1 ? tip.executionTime : tip.planStartTime }}
                </el-col>
            </el-row>
            <el-row :gutter="16">
                <el-col class="laber"> {{ translate('taskPage.left.executionMethod') }} </el-col>
                <el-col :span="17">
                    {{ getModelName(tip.model) }}
                </el-col>
            </el-row>
            <el-row :gutter="16">
                <el-col class="laber"> <div class="letter-40">{{ translate('taskPage.left.site') }}</div> </el-col>
                <el-col :span="17">
                    {{ tip.siteName || '--' }}
                </el-col>
            </el-row>
            <el-row :gutter="16">
                <el-col class="laber"> <div class="letter-40">{{ translate('taskPage.left.airline') }}</div> </el-col>
                <el-col :span="17">
                    {{ tip.routeName || '--' }}
                </el-col>
            </el-row>
            <el-row :gutter="16" v-if="tip.routeName">
                <el-col :span="24">
                    <div class="tooltip-info">
                        <div class="map-info">
                            <!-- <DetailMap
                                :key="tip.siteId + tip.routeId"
                                :routeId="tip.routeId"
                                :siteId="tip.siteId"
                                :BottomToo="false"
                                :SeeStute="false"
                                :EditShow="false"
                            ></DetailMap> -->
                            <Render :render="renderMap" />
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import { Render } from '@CommonComponent';
import api from '@/page/routePage/main/api.js';
import Airline from '@/page/routePage/main/Airline.vue';
import DetailMap from '../../component/item/TaskDetailMap/DetailMap.vue';
import MixMapCtl from '@/page/mainPage/map/mixmap/MixMapCtl';

let LineMapModule = null;

export default {
    // DetailMap
    components: { Render },
    props: {
        tip: {
            type: Object,
            require: true,
            default: () => {},
        },
        modelData: {
            type: Array,
            default: () => [],
        },
        width: {
            type: Number,
            require: true,
            default: () => {},
        },
        modules: Object,
        translate: Function,
    },
    data() {
        return {
            airlineConfig: {},
        };
    },
    beforeCreate() {
        if (!LineMapModule) {
            LineMapModule = new MixMapCtl({
                talksE: false,
                showSearch: false,
                showZoomTool: false,
                showBottomBar: false,
            }).init();
        }
        this.LineMapModule = LineMapModule;
    },
    watch: {
        tip: {
            handler(newVal) {
                console.log('tip', newVal);

                if (newVal.routeId) {
                    this.getAirline(newVal.routeId);
                }
            },
            immediate: true,
            deep: true,
        },
    },
    mounted() {
        this.LineMapModule.input.map2dContent.delete(this.renderMapLayers);
        this.LineMapModule.input.map2dContent.push(this.renderMapLayers);
        // this.modules.MainModule.MixMapModule.input.map2dContent.push(this.renderMapLayers);
    },
    beforeDestroy() {
        this.LineMapModule.input.map2dContent.delete(this.renderMapLayers);
        // this.modules.MainModule.MixMapModule.input.map2dContent.delete(this.renderMapLayers);
    },
    methods: {
        renderMap() {
            // return this.LineMapModule.output.default();
            return [this.LineMapModule.output.default()];
        },
        getModelName(val) {
            const result = this.$props.modelData.filter((item) => item.dictValue === val)[0];
            return result.dictLabel;
        },
        getAirline(id) {
            this.airlineConfig = {};
            api.getRouteInfo(id).then((res) => {
                // console.log('sdgdagdadag', data);
                let { coordinates } = res.data;
                let j = coordinates && JSON.parse(coordinates);
                this.airlineConfig = { ...j.routePoints };
            });
        },
        renderMapLayers() {
            // 这个是hover的任务信息
            let airlineConfig = this.airlineConfig;
            let type = '';
            let routeObj = {
                RouteValue: '',
                lineType: airlineConfig.type,
                searchHive: {},
                SeeShow: true,
                airT: 0,
                CurrentVal: {},
                rightShow: false,
                importState: false,
                altitudeLayers: [],
            };
            return <Airline type={type} routeObj={routeObj} airlineConfig={airlineConfig}></Airline>;
        },
    },
};
</script>
<style lang="scss" scoped>
.task-info-edital {
    color: white;
    font-size: 14px;
    line-height: 24px;
    vertical-align: middle;
    .title {
        color: #49f0fd;
        font-size: 17px;
        height: auto;
        line-height: 24px;
        width: 100%;
        word-wrap: break-word;
        word-break: break-all;
        padding-bottom: 6px;
    }
    .laber {
        color: rgba(255, 255, 255, 0.7);
        width: 76px;

        .letter-40 {

            letter-spacing: 15px;
        }
    }
    .timelaber {
        color: rgba(255, 255, 255, 0.7);
        width: 100px;
    }
    .value {
        display: inline-block;
        height: 22px;

        margin-left: 8px;
        padding: 0 3px;
        text-align: center;
        width: auto;
        // min-width: 50px;
    }
    .line-height-20{
        line-height: 18px;
    }
    .map-info {
        width: 325px;
        height: 220px;
        padding-top: 5px;
    }
}
</style>
